const BOT_CREATION = '/bot/creation'

const WEBCHAT = '/webchat'

export { BOT_CREATION, WEBCHAT }
